module.exports = __webpack_public_path__ + "assets/3-sales-development-representative-salary.ff4dcf10.png";